// import 'material-pickers-calendar/dist/Calendar.css';

import DateRangePicker from './DateRangePicker';

// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
// import './DateRangePicker.less';

export default DateRangePicker;
